import { FC } from "react";
import { IconProps } from "./types";

export const Globe: FC<IconProps> = ({
  className,
  color = "#111111",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="29"
    fill="none"
    viewBox="0 0 29 29"
    className={className}
    {...props}
  >
    <path
      fill={color}
      d="M14.5 0a14.5 14.5 0 0 0 0 29 14.5 14.5 0 0 0 0-29zm.6 8.7a21.4 21.4 0 0 0 4.5-.6c.4 1.9.7 3.9.7 5.8h-5.2V8.7zm0-1.2V1.3c1.5.4 3.1 2.5 4.1 5.7a20.4 20.4 0 0 1-4.1.5zm-1.2-6.3v6.3A20.1 20.1 0 0 1 9.7 7c1-3.3 2.6-5.4 4.2-5.8zm0 7.5v5.2H8.7c0-2 .2-4 .7-5.8l4.5.6zm-6.4 5.2H1.2a13.3 13.3 0 0 1 3-7.9 21.1 21.1 0 0 0 4 1.8 27.4 27.4 0 0 0-.7 6.1zm0 1.2c0 2 .3 4.1.8 6.1A21.7 21.7 0 0 0 4.2 23a13.3 13.3 0 0 1-3-8h6.3zm1.2 0h5.2v5.2c-1.5 0-3 .3-4.5.6a26 26 0 0 1-.7-5.8zm5.2 6.4v6.3c-1.6-.4-3.2-2.5-4.2-5.8a19.8 19.8 0 0 1 4.2-.5zm1.2 6.2v-6.2c1.4 0 2.8.2 4.1.5-1 3.2-2.6 5.3-4.1 5.7zm0-7.4v-5.2h5.2a26 26 0 0 1-.7 5.8 21.4 21.4 0 0 0-4.5-.6zm6.4-5.2h6.3a13.3 13.3 0 0 1-3 7.9 21.5 21.5 0 0 0-4.1-1.8c.5-2 .7-4 .8-6.1zm0-1.2a27.3 27.3 0 0 0-.8-6.1A21.6 21.6 0 0 0 24.8 6a13.3 13.3 0 0 1 3 8h-6.3zM24 5.2a20.2 20.2 0 0 1-3.6 1.5 13 13 0 0 0-2.8-5.2A13.4 13.4 0 0 1 24 5.2zM11.3 1.5a12.9 12.9 0 0 0-2.7 5.2L5 5.2a13.2 13.2 0 0 1 6.3-3.7zM5 23.8a20 20 0 0 1 3.6-1.5 13 13 0 0 0 2.7 5.2A13.3 13.3 0 0 1 5 23.8zm12.6 3.7a13 13 0 0 0 2.8-5.2l3.6 1.5a13.4 13.4 0 0 1-6.4 3.7z"
    />
  </svg>
);
